import React, { PureComponent } from 'react';

import {
    View,
    StyleSheet
} from 'react-native';

import {
    JDText,
    JDTouchable,
    JDImage
} from '@jdreact/jdreact-core-lib';

import { pt } from '../../../common/utils';

class CityScreening extends PureComponent {
    static defaultProps = {
        currentSearchType: null,
        currentRegion: {
            regionName: '全城',
            regionId: 0
        },
        currentBrand: {
            brandId: 0,
            brandName: '品牌'
        },
        currentDiscount: {
            discountId: '0',
            discountName: '筛选'
        }
    }

    render() {
        const { 
            scheduledType,
            currentRegion, currentBrand, currentDistance, currentDiscount, currentSearchType, govSubsidy
         } = this.props;

        return (
            <View>
                <View style={ st.screening }>
                    <View style={ { flex: 1 } }>
                        <JDTouchable onPress={ () => { this.props.scrollToCity('region'); } }>
                            <View style={ st.t_item }>
                                <JDText numberOfLines={ 1 } style={ currentSearchType === 'region' ? st.search_current_text : st.search_text }>{currentRegion.regionName}</JDText>
                                <JDImage style={ st.arrow } source={ currentSearchType === 'region' ? img.arrow_top : img.arrow_bottom } />
                            </View>
                        </JDTouchable>
                    </View>
                    <View style={ { flex: 1 } }>
                        <JDTouchable onPress={ () => { this.props.scrollToCity('brand'); } }>
                            <View style={ st.t_item }>
                                <JDText numberOfLines={ 1 } style={ currentSearchType === 'brand' ? st.search_current_text : st.search_text }>{currentBrand.brandName}</JDText>
                                <JDImage style={ st.arrow } source={ currentSearchType === 'brand' ? img.arrow_top : img.arrow_bottom } />
                            </View>
                        </JDTouchable>
                    </View>
                    <View style={ { flex: 1 } }>
                        <JDTouchable onPress={ () => { this.props.scrollToCity('distance'); } }>
                            <View style={ st.t_item }>
                                <JDText numberOfLines={ 1 } style={ currentSearchType === 'distance' ? st.search_current_text : st.search_text }>{currentDistance.distanceName}</JDText>
                                <JDImage style={ st.arrow } source={ currentSearchType === 'distance' ? img.arrow_top : img.arrow_bottom } />
                            </View>
                        </JDTouchable>
                    </View>
                    {
                        govSubsidy? 
                            <View style={ { flex: 1, position: 'relative' } }>
                                <View style={ st.gov }><JDImage style={ st.img } source={ img.gov } /></View>
                                <JDTouchable onPress={ () => { this.props.scrollToCity('discount'); } }>
                                    <View style={ st.t_item }>
                                        <JDText numberOfLines={ 1 } style={ currentSearchType === 'discount' ? st.search_current_text : st.search_text }>{currentDiscount.discountName}</JDText>
                                        <JDImage style={ st.arrow } source={ currentSearchType === 'discount' ? img.arrow_top : img.arrow_bottom } />
                                    </View>
                                </JDTouchable>
                            </View>
                        : null
                    }
                    
                </View>
            </View>
        );
    }
}

const img = {
    arrow_bottom: require('../../../img/arrow_bottom.png'),
    arrow_top: require('../../../img/arrow_top.png'),
    rightImg: require('./img/rightImg.png'),
    triangle: require('./img/triangle.png'),
    gov: require('./img/green_gov.png')
};
const st = StyleSheet.create({
    screening: {
        flexDirection: 'row',
        alignItems: 'center',
        backgroundColor: '#fff',
        borderBottomColor: 'rgba(0,0,0,0.1)',
        borderBottomWidth: pt(1)
    },
    t_item: {
        justifyContent: 'center',
        height: pt(36),
        flexDirection: 'row',
        alignItems: 'center',
        overflow: 'hidden'
    },
    search_text: {
        maxWidth: '80%',
        color: '#666666',
        fontSize: pt(12)
    },
    search_current_text: {
        maxWidth: '80%',
        color: '#E2231A',
        fontSize: pt(12)
    },
    arrow: {
        width: pt(7),
        height: pt(5),
        marginLeft: pt(5)
    },
    gov: {
        width: '100%',
        position: 'absolute',
        left: '0',
        top: pt(-4),
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center'
    },
    img: {
        width: pt(48),
        height: pt(14)
    }


});

export default CityScreening;
